import {
  ApproveDto,
  CreateRegistrationDto,
  DeleteRegistrationDto,
  EditRegistrationDto,
  GetRegistrationDto,
  MessageResponseDto,
  RegistrationApiFp,
  RegistrationControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseRegistrationModel = RegistrationControllerGet200Response;
export type GetRegistrationModel = GetRegistrationDto;
export type MutateResponseRegistrationModel = MessageResponseDto;
export type CreateRegistrationModel = CreateRegistrationDto;
export type UpdateRegistrationModel = EditRegistrationDto;
export type DeleteRegistrationModel = DeleteRegistrationDto;
export type ApproveRegistrationModel = ApproveDto;
export type CheckBookingLimitResponseModel = MessageResponseDto;

export const apiRegistrationFp = RegistrationApiFp(apiConfig);
export const getRegistrationController =
  apiRegistrationFp.registrationControllerGet;
export const createRegistrationController =
  apiRegistrationFp.registrationControllerCreate;
export const updateRegistrationController =
  apiRegistrationFp.registrationControllerEdit;
export const deleteRegistrationController =
  apiRegistrationFp.registrationControllerDelete;
export const checkRegistrationBookingLimitController =
  apiRegistrationFp.registrationControllerCheckDailyBookingLimit;

export const approveRegistrationController =
  apiRegistrationFp.registrationControllerEnd;

export const QueryKeyRegistration = QueryKey.Registration;
